import React, {Component, ReactElement} from "react";


class MySettings extends Component {
    render(): ReactElement {
        return <h1>PersonalSettings!!!</h1>
    }
}

export default MySettings;